import { Component, OnInit } from '@angular/core';
import {ApiService} from '../api/api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-activation-handler',
  templateUrl: './activation-handler.component.html',
  styleUrls: ['./activation-handler.component.css']
})
export class ActivationHandlerComponent implements OnInit {

  constructor(
    private api: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    const email = this.activatedRoute.snapshot.paramMap.get("email")
    const passket = this.activatedRoute.snapshot.paramMap.get("passkey")
    const partner = this.activatedRoute.snapshot.paramMap.get("partner")

    console.log(btoa(email))
    console.log(passket)
    console.log(partner)

    this.api.activateAccount(btoa(email), passket, partner).subscribe(() => {

    })

    window.location.replace('https://assetstore.assetx.it/login/admin/vps-manager')

    //this.router.navigateByUrl('https://assetstore.assetx.it/login/admin/vps-manager')
  }
}
